import Vue from "vue";
export interface IApiError {
    errors?: IFieldError[] | null;
    message: string;
    responseCode?: string | null;
    isError?: boolean;
}

export interface IFieldError {
    field: string;
    messages: string[];
}

export class ApiError implements IApiError {
    public message: string = "";
    public errors: IFieldError[] | null = null;
    public isError: boolean = true;
    public responseCode: string | null = null;

    constructor(error: IApiError) {
        this.message = error.message;
        this.errors = error.errors || null;
        this.isError = error.isError || true;
        this.responseCode = error.responseCode || null;
    }

    public displayError() {
        Vue.prototype.$toast(this.message, {
            icon: this.isError ? "error" : "warning",
            color: this.isError ? "error" : "warning",
        });
    }
}
